const EXCLUDED_STORES_PREFIX = 'DO_NOT_USE_';

const slicer = state => state.data.clickCollect;

export const selectStores = state => slicer(state).stores;
export const selectNoStoresAvailable = state => Object.values(selectStores(state) ?? {}).length === 0;
export const selectFilteredStores = state => Object.values(selectStores(state) ?? {}).filter(s => s.name && !s.name.includes(EXCLUDED_STORES_PREFIX));
export const selectSelectedStoreId = state => slicer(state).selectedStore;
export const selectError = state => slicer(state).error;
